import { ScrollReveal } from "./ScrollReveal";
import {
  Upload,
  ShieldCheck,
  Globe,
  Headphones,
  CheckCircle,
} from "lucide-react";

const steps = [
  { icon: Upload, title: "Property Posted", desc: "Owner submits details" },
  { icon: ShieldCheck, title: "Team Verifies", desc: "We verify everything" },
  { icon: Globe, title: "Goes Live", desc: "Published on platform" },
  { icon: Headphones, title: "Broker Handles", desc: "Manages all inquiries" },
  { icon: CheckCircle, title: "Deal Closed", desc: "Successful completion" },
];

const HowItWorksSection = () => (
  <section className="section-light py-20 sm:py-28">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-xs font-medium uppercase tracking-[0.15em] text-muted-foreground text-center mb-3">
          Process
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4 text-foreground">
          How <span className="gradient-text font-extrabold">PRObroker</span>{" "}
          Works
        </h2>
        <p className="text-center text-muted-foreground mb-14 max-w-md mx-auto text-sm leading-relaxed">
          From listing to closing — a seamless 5-step process.
        </p>
      </ScrollReveal>

      <div className="relative max-w-4xl mx-auto">
        {/* Connecting line */}
        <div className="hidden lg:block absolute top-10 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-border to-transparent" />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-4">
          {steps.map((step, i) => (
            <ScrollReveal key={i} delay={i * 0.08}>
              <div className="flex flex-col items-center text-center group">
                <div className="relative z-10 w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-background border border-border flex items-center justify-center mb-3 group-hover:border-primary/20 group-hover:shadow-md transition-all duration-300">
                  <step.icon className="w-6 h-6 text-primary" />
                  <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-primary text-primary-foreground text-[10px] font-semibold flex items-center justify-center">
                    {i + 1}
                  </span>
                </div>
                <h4 className="font-semibold text-xs sm:text-sm text-foreground mb-0.5">
                  {step.title}
                </h4>
                <p className="text-[11px] text-muted-foreground">{step.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
